export interface TransitionProps {
  event: "SUCCESS" | "ERROR" | "START";
  target: number;
}

export class Transition {
  event: TransitionProps["event"];
  target: TransitionProps["target"];

  constructor({ event, target }: TransitionProps) {
    this.event = event;
    this.target = target;
  }

  public formatToSend() {
    return {
      event: this.event,
      target: this.target,
    };
  }
}
